<template>
  <OpenSpaceLinksFilters
    :filters="this.filters"
    :onChange="this.onFiltersChange"
    :get-data="this.getData"
  />
  <div style="max-width: 700px;">
    <CustomTable
      title="OpenSpace ссылки"
      :rowsData="this.rowsData"
      :columns="this.openSpaceLinksColumns"
      :loading="isFetching"
      :custom-body="true"
      :small="true"
      :striped="false"
    >
      <template #customBody="props">
        <q-tr class="groupWrapper">
          <custom-table-cell align="left" verticalAlign="center">
            {{props.row.resident_name}}
          </custom-table-cell>
          <custom-table-cell align="center" verticalAlign="center">
            {{props.row.entrance}}
          </custom-table-cell>
          <custom-table-cell align="center" verticalAlign="center">
            {{props.row.block_name}}
          </custom-table-cell>
          <custom-table-cell align="center" verticalAlign="center">
            {{props.row.floor}}
          </custom-table-cell>
          <custom-table-cell align="center" verticalAlign="center">
            <div class="openSpaceLinkList" v-if="!!props.row.floor_map_id">
              <CustomIcon
                @click="() => this.handleAddLink(props.row.floor_map_id)"
                icon="add"
                title="Добавить ссылку"
                green
              />
              <CustomPopup width="420" :noPadding="true">
                <template #head>
                  <div>
                    <CustomIcon
                      icon="fas fa-link"
                      primary
                      small
                      class="linksIcon"
                      title="Показать ссылки"
                    />
                    <span class="linksCount"
                      >{{ props.row.count_url || 0 }}
                      <q-tooltip>Кол-во ссылок</q-tooltip></span
                    >
                  </div>
                </template>
                <template #default>
                  <LinksTable
                    :floor_map_id="props.row.floor_map_id"
                    :filters="this.filters"
                    :onDataChange="this.onDataChange"
                  />
                </template>
              </CustomPopup>
            </div>
          </custom-table-cell>
        </q-tr>
      </template>
    </CustomTable>
  </div>
</template>

<script>
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";
import CustomIcon from "@/components/common/CustomIcon";
import CustomPopup from "@/components/common/CustomPopup";
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import { MODAL_NAMES } from "@/constants";
import { useAppStore } from "@/services/store/app";
import OpenSpaceLinksFilters from "./filters.vue";
import LinksTable from "./LinksTable.vue";
import { addOpenSpaceLink, getOpenSpaceLinks, openSpaceLinksColumns } from "./services";

export default {
  name: "OpenSpaceLinks",
  components: {CustomIcon, CustomTableCell, CustomTable,CustomPopup, OpenSpaceLinksFilters, LinksTable},
  data() {
    return {
      openSpaceLinksColumns,
      rowsData: [],
      isFetching: false,
      filters: {
        resident_id: '',
        project_type_id: '',
        project_entrance_id: '',
      },
    }
  },
  methods: {
    async getData(filters) {
      this.isFetching = true
      const res = await getOpenSpaceLinks(filters)
      this.isFetching = false
      this.rowsData = res || []
    },
    onDataChange(data) {
      this.rowsData = data
    },
    onFiltersChange(object) {
      if(!object) return
      this.filters = {
        ...this.filters,
        ...object,
      }
      if(!this.filters.resident_id)
        this.rowsData = []
    },
    handleAddLink(floor_map_id) {
      if(!floor_map_id) return
      this.showModal(MODAL_NAMES.addOpenSpaceLink, {
        title: 'Добавить ссылку',
        onSubmit: body => this.onSubmitAddLink({...body, floor_map_id})
      })
    },
    async onSubmitAddLink(body) {
      const res = await addOpenSpaceLink(body, this.filters)
      if(!res) return
      this.rowsData = res
      this.showSucceedSnackbar()
      this.closeModal()
    }
  },
  setup() {
    const {showModal, closeModal} = useAppStore()
    const {showSucceedSnackbar} = useCustomSnackbar();
    return {showSucceedSnackbar, showModal, closeModal};
  },
}
</script>

<style scoped lang="scss">
.groupWrapper {
    position: sticky;
    top: 48px;
    z-index: 49;
}
.openSpaceLinkEssential {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ccc;
  height: 24px;
  width: 113px;

  & > span {
    line-height: 14px;
    font-size: 12px;
    white-space: nowrap;
  }
  &:last-child{
    border: none
  }
}
.openSpaceLinkList {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}
.actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
.linksCount {
  margin-left: 7px;
  font-weight: 700;
  color: #0c3973;
}
</style>
